import React from "react";
import { motion } from "framer-motion";
import { Feather, Target } from "lucide-react";

export default function AboutSection({ settings, content }) {
  return (
    <section id="about" data-testid="about-section" className="py-20 md:py-28 bg-[#1A0F0E]">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <div className="text-center mb-14">
          <div className="text-[#F0E8DB] text-xs tracking-[0.4em] font-serif-en mb-3">ABOUT · MISSION</div>
          <h2 className="section-title text-3xl sm:text-4xl lg:text-5xl">{content.titles.about}</h2>
          <div className="w-24 h-px bg-gradient-to-r from-transparent via-[#F0E8DB] to-transparent mx-auto mt-6" />
        </div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-10">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="theater-card rounded-2xl p-8 relative"
          >
            <div className="w-12 h-12 rounded-lg bg-[#7A2E2A]/30 border border-[#F0E8DB]/40 flex items-center justify-center mb-5">
              <Feather className="text-[#F0E8DB]" size={22} />
            </div>
            <h3 className="text-2xl font-semibold text-[#F0E8DB] mb-4">نبذة عن النادي</h3>
            <p className="text-[#C5B8A8] leading-loose text-base whitespace-pre-line">
              {settings?.about}
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="theater-card rounded-2xl p-8 relative"
          >
            <div className="w-12 h-12 rounded-lg bg-[#7A2E2A]/30 border border-[#F0E8DB]/40 flex items-center justify-center mb-5">
              <Target className="text-[#F0E8DB]" size={22} />
            </div>
            <h3 className="text-2xl font-semibold text-[#F0E8DB] mb-4">رسالتنا</h3>
            <p className="text-[#C5B8A8] leading-loose text-base whitespace-pre-line">
              {settings?.mission}
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
